export default "__VITE_ASSET__DWAQvo5d__"